import { apiList, $axios } from '@/api'
import inMemoryCacheFactory from '@/script/cache/utils'
import md5 from '@/script/md5'

export default {
    actions: {
        /**
         *
         * @param {Object} _
         * @param {Object} payload API paramaters payload = { user, course }
         * @returns
         */
        getActivitiesCompletionStatus(_, payload) {
            payload.user = payload.user ?? _.getters.user.id

            const cacheName = 'activities-completion'
            const customCacheName = `${cacheName}-` + md5(JSON.stringify(payload))

            const cache = inMemoryCacheFactory(cacheName)
            if (cache.loading[customCacheName]) return cache.loading[customCacheName]

            const { resolved, notfound } = cache.read([customCacheName])
            if (notfound.length === 0) {
                return Promise.resolve(resolved[customCacheName])
            }

            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.activities.getActivitiesCompletionStatus.method,
                    params: {
                        wsfunction: apiList.activities.getActivitiesCompletionStatus.moodle_method,
                        courseid: payload.course,
                        userid: payload.user
                    }
                })
                    .then(resp => {
                        cache.save({ [customCacheName]: resp.data })
                        resolve(resp.data)
                    }).catch(err => {
                    cache.stop(customCacheName)
                    reject(err)
                })
            })
        },
        updateActivityCompletionStatus(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.activities.updateActivityCompletionStatus.method,
                    params: {
                        wsfunction: apiList.activities.updateActivityCompletionStatus.moodle_method
                    },
                    data: {
                        cmid: payload.cmid,
                        completed: payload.state
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
